import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { usePatchQuote as usePatchQuoteAPI } from "../../../../fnx/quotes/patchQuote";
import { patchQuoteClearData } from "../../../../store/updateQuote/actions";
import { quoteAddFields, quoteAddFieldsClearData, } from "../../../../store/generateQuote/actions";
export var usePatchQuoteManagement = function (_a) {
    var triggerPatchQuote = _a.triggerPatchQuote, bodyPatchQuote = _a.bodyPatchQuote, quoteId = _a.quoteId, paymentModeId = _a.paymentModeId, setTriggerPatchQuote = _a.setTriggerPatchQuote, onPatchSuccess = _a.onPatchSuccess;
    var dispatch = useDispatch();
    var _b = usePatchQuoteAPI(triggerPatchQuote, bodyPatchQuote, quoteId, function () {
        return setTriggerPatchQuote(false);
    }), responsePatchQuote = _b.responsePatchQuote, errorPatchQuote = _b.errorPatchQuote, loadingPatchQuote = _b.loadingPatchQuote;
    var _c = useSelector(function (state) { return ({
        responseQuoteAddFields: state.Quote.responseQuoteAddFields,
        errorQuoteAddFields: state.Quote.errorQuoteAddFields,
        loadingQuoteAddFields: state.Quote.loadingQuoteAddFields,
    }); }), responseQuoteAddFields = _c.responseQuoteAddFields, errorQuoteAddFields = _c.errorQuoteAddFields, loadingQuoteAddFields = _c.loadingQuoteAddFields;
    var callQuoteAddFields = function () {
        var body = {
            value: paymentModeId,
        };
        dispatch(quoteAddFields({ id: quoteId, key: "paymentFrequency", body: body }));
    };
    useEffect(function () {
        if (responsePatchQuote) {
            callQuoteAddFields();
            dispatch(patchQuoteClearData());
        }
    }, [responsePatchQuote]);
    useEffect(function () {
        if (responseQuoteAddFields && responseQuoteAddFields.data) {
            onPatchSuccess();
            dispatch(quoteAddFieldsClearData());
        }
    }, [responseQuoteAddFields]);
    return {
        responsePatchQuote: responsePatchQuote,
        errorPatchQuote: errorPatchQuote,
        loadingPatchQuote: loadingPatchQuote,
        responseQuoteAddFields: responseQuoteAddFields,
        errorQuoteAddFields: errorQuoteAddFields,
        loadingQuoteAddFields: loadingQuoteAddFields,
        callQuoteAddFields: callQuoteAddFields,
    };
};
